import { render, staticRenderFns } from "./OptionsPanel.vue?vue&type=template&id=89966b38&scoped=true"
import script from "./OptionsPanel.vue?vue&type=script&lang=js"
export * from "./OptionsPanel.vue?vue&type=script&lang=js"
import style0 from "./OptionsPanel.vue?vue&type=style&index=0&id=89966b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89966b38",
  null
  
)

export default component.exports